export const DEFAULT_LIMIT: number = 10;

export const TS_LIMIT: number = 15;

export const EB_LIMIT: number = 20;

// Batch list polling while rows are unfinished: starts at the base, doubles per
// unchanged poll, capped at the max.
export const EB_POLL_BASE_MS: number = 7000;

export const EB_POLL_MAX_MS: number = 30000;

export const DOC_LIMIT: number = 100;

export const PER_CHUNK: number = 5;

export const TAG_LIMIT: number = 100;

export const LABEL_LIMIT: number = 63;

export const DOC_LABEL_LIMIT: number = 255;

export const FIELD_CONTENT_LIMIT: number = 255;

export const MIN_TRAIN_DOCS: number = 8;

export const TRAINING_SET_PAGINATION: number = 2000;

// Timeout (in ms) for refetching extractions after correction
export const REFETCH_AFTER_CORRECTION_MS: number = 5000;

// Default number of fields per page - Note there is currently a back-end limit
// to 150. If this is to be increased, the back-end needs to be updated as well.
export const FIELDS_PAGE_SIZE = 150;

// Used for fuzzy searching mismatched tokens. This must match what is in
// core/core_cluster/4_0_0/src/settings.py in glynt-core project
export const GROUND_TRUTH_PIXEL_FUZZ_VALUE = 10;

export const DUPLICATE_SUCCESS_DELAY = 750;

export const CORE_VERSION: string = '4.0.0';

// Tooltip descriptions
export const DOCUMENT_DATA_STATUS_TOOLTIP: string =
  'Tracks the processing lifecycle of extracted/transformed document data.';
